module.exports = __webpack_public_path__ + "static/media/cases_brand_riovermelho_04.21576f1e.jpg";